import { cn } from '@/lib/utils';
import { useTranslation } from 'react-i18next';

type FeedbackStatus = 'draft' | 'in_progress' | 'completed' | 'cancelled';

const STATUS_STYLES: Record<FeedbackStatus, string> = {
  draft: 'bg-gray-100 text-gray-600 border-gray-200',
  in_progress: 'bg-blue-100 text-blue-700 border-blue-200',
  completed: 'bg-emerald-100 text-emerald-700 border-emerald-200',
  cancelled: 'bg-red-100 text-red-700 border-red-200',
};

interface StatusBadgeProps {
  status: FeedbackStatus;
  className?: string;
}

export function StatusBadge({ status, className }: StatusBadgeProps) {
  const { t } = useTranslation();
  return (
    <span className={cn('inline-flex items-center rounded-full border px-2.5 py-0.5 text-xs font-medium', STATUS_STYLES[status] ?? STATUS_STYLES.draft, className)}>
      {t(`performance.status.${status}`, { defaultValue: status })}
    </span>
  );
}
